"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const paymentOptions = [
    {
        id: 6065,
        paymentType: "DLOCALPIX",
        name: "PIX",
        description: "Pix",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/dlocalpix.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["BRL"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "MATIC",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "BRL",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "BRL",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "BRL",
                min: "200",
                max: "25000",
                weekly: "100000",
            },
        ],
    },
    {
        id: 6024,
        paymentType: "IDEAL",
        name: "iDEAL",
        description: "Ideal Payments allow you to buy digital currency by bank transfer using your internet banking",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/ideal.svg",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["EUR"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "EUR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "EUR",
                min: "35",
                max: "30000",
                weekly: "70000",
            },
        ],
    },
    {
        id: 6068,
        paymentType: "MANUALPAYMENT",
        name: "Turkish Bank Transfer",
        description: "Pay for your order directly from your internet banking app, just like paying a bill",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/default-landscape.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["TRY"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "MCK",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "RUNE",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "TRY",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "TRY",
                min: "700",
                max: "40000",
                weekly: "160000",
            },
        ],
    },
    {
        id: 6080,
        paymentType: "WORLDPAYCREDIT",
        name: "Visa/Mastercard",
        description: "Conveniently buy digital currency using your personal VISA or MasterCard.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/worldpaycredit.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["CAD", "USD"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "CAD",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CAD",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "USD",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "CAD",
                min: "50",
                max: "24000",
                weekly: "80000",
            },
            {
                fiat_code: "USD",
                min: "35",
                max: "18000",
                weekly: "75000",
            },
        ],
    },
    {
        id: 5021,
        paymentType: "POLI",
        name: "POLi",
        description: "POLi Payments allow you to buy digital currency by bank transfer using your internet banking",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/poli.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["AUD"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "AUD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "AUD",
                min: "50",
                max: "50000",
                weekly: "200000",
            },
        ],
    },
    {
        id: 6026,
        paymentType: "WORLDPAYCREDIT",
        name: "Visa/Mastercard",
        description: "Conveniently buy digital currency using your personal VISA or MasterCard.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/worldpaycredit.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: [
            "CZK",
            "DKK",
            "HKD",
            "JPY",
            "NGN",
            "NOK",
            "NZD",
            "PLN",
            "SEK",
            "SGD",
            "TRY",
        ],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "CZK",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CZK",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "DKK",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "HKD",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "JPY",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NGN",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NOK",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "NZD",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PLN",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SEK",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SGD",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TRY",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "CZK",
                min: "800",
                max: "50000",
                weekly: "65000",
            },
            {
                fiat_code: "DKK",
                min: "250",
                max: "30000",
                weekly: "210000",
            },
            {
                fiat_code: "HKD",
                min: "300",
                max: "50000",
                weekly: "225000",
            },
            {
                fiat_code: "JPY",
                min: "5000",
                max: "800000",
                weekly: "3000000",
            },
            {
                fiat_code: "NGN",
                min: "16500",
                max: "230000",
                weekly: "920000",
            },
            {
                fiat_code: "NOK",
                min: "350",
                max: "60000",
                weekly: "350000",
            },
            {
                fiat_code: "NZD",
                min: "55",
                max: "15000",
                weekly: "42500",
            },
            {
                fiat_code: "PLN",
                min: "160",
                max: "17000",
                weekly: "85000",
            },
            {
                fiat_code: "SEK",
                min: "375",
                max: "50000",
                weekly: "300000",
            },
            {
                fiat_code: "SGD",
                min: "50",
                max: "10000",
                weekly: "42500",
            },
            {
                fiat_code: "TRY",
                min: "700",
                max: "60000",
                weekly: "482000",
            },
        ],
    },
    {
        id: 6027,
        paymentType: "WORLDPAYCREDIT",
        name: "Visa/Mastercard",
        description: "Conveniently buy digital currency using your personal VISA or MasterCard.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/worldpaycredit.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["GBP"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "GBP",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "GBP",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "GBP",
                min: "30",
                max: "14000",
                weekly: "30000",
            },
        ],
    },
    {
        id: 6033,
        paymentType: "WORLDPAYGOOGLE",
        name: "Google Pay",
        description: "Conveniently buy digital currency using your Google Pay wallet.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/google-pay.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["AUD"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "MCK",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "RUNE",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "AUD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "AUD",
                min: "50",
                max: "15000",
                weekly: "60000",
            },
        ],
    },
    {
        id: 6034,
        paymentType: "WORLDPAYGOOGLE",
        name: "Google Pay",
        description: "Conveniently buy digital currency using your Google Pay wallet.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/google-pay.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: [
            "AED",
            "CAD",
            "CHF",
            "CZK",
            "DKK",
            "EUR",
            "HKD",
            "IDR",
            "INR",
            "KRW",
            "MXN",
            "NOK",
            "NZD",
            "PHP",
            "PLN",
            "QAR",
            "SAR",
            "SEK",
            "SGD",
            "THB",
            "TRY",
            "TWD",
            "VND",
            "ZAR",
        ],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "MCK",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "RUNE",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "AED",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "AED",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "CHF",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "CZK",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "DKK",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "HKD",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "IDR",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "INR",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "KRW",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "NOK",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "NZD",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "PHP",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "PLN",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "QAR",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "SAR",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "SEK",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "SGD",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "TRY",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "TWD",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "VND",
                coin_code: "VERSE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "AED",
                min: "125",
                max: "5000",
                weekly: "130000",
            },
            {
                fiat_code: "CAD",
                min: "50",
                max: "1000",
                weekly: "42500",
            },
            {
                fiat_code: "CHF",
                min: "40",
                max: "15000",
                weekly: "32000",
            },
            {
                fiat_code: "CZK",
                min: "800",
                max: "50000",
                weekly: "65000",
            },
            {
                fiat_code: "DKK",
                min: "250",
                max: "30000",
                weekly: "210000",
            },
            {
                fiat_code: "EUR",
                min: "35",
                max: "14000",
                weekly: "30000",
            },
            {
                fiat_code: "HKD",
                min: "300",
                max: "50000",
                weekly: "225000",
            },
            {
                fiat_code: "IDR",
                min: "550000",
                max: "8250000",
                weekly: "33000000",
            },
            {
                fiat_code: "INR",
                min: "3000",
                max: "50000",
                weekly: "180000",
            },
            {
                fiat_code: "KRW",
                min: "45000",
                max: "18900000",
                weekly: "40500000",
            },
            {
                fiat_code: "MXN",
                min: "650",
                max: "20000",
                weekly: "50000",
            },
            {
                fiat_code: "NOK",
                min: "350",
                max: "60000",
                weekly: "350000",
            },
            {
                fiat_code: "NZD",
                min: "55",
                max: "10000",
                weekly: "42500",
            },
            {
                fiat_code: "PHP",
                min: "2000",
                max: "30000",
                weekly: "120000",
            },
            {
                fiat_code: "PLN",
                min: "160",
                max: "17000",
                weekly: "85000",
            },
            {
                fiat_code: "QAR",
                min: "125",
                max: "59000",
                weekly: "130000",
            },
            {
                fiat_code: "SAR",
                min: "135",
                max: "61000",
                weekly: "130000",
            },
            {
                fiat_code: "SEK",
                min: "375",
                max: "50000",
                weekly: "300000",
            },
            {
                fiat_code: "SGD",
                min: "50",
                max: "1000",
                weekly: "42500",
            },
            {
                fiat_code: "THB",
                min: "1200",
                max: "20000",
                weekly: "80000",
            },
            {
                fiat_code: "TRY",
                min: "700",
                max: "60000",
                weekly: "482000",
            },
            {
                fiat_code: "TWD",
                min: "1000",
                max: "455750",
                weekly: "1825000",
            },
            {
                fiat_code: "VND",
                min: "850000",
                max: "375000000",
                weekly: "750000000",
            },
            {
                fiat_code: "ZAR",
                min: "600",
                max: "10000",
                weekly: "40000",
            },
        ],
    },
    {
        id: 6035,
        paymentType: "WORLDPAYGOOGLE",
        name: "Google Pay",
        description: "Conveniently buy digital currency using your Google Pay wallet.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/google-pay.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["GBP"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "MCK",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "RUNE",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "GBP",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MCK",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "GBP",
                min: "30",
                max: "14000",
                weekly: "30000",
            },
        ],
    },
    {
        id: 6046,
        paymentType: "DCINTERAC",
        name: "Interac e-Transfer",
        description: "Interac allows you to pay for your order directly from your internet banking, just like paying a bill",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/interac.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["CAD"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "WAXP",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "CAD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "CAD",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "CAD",
                min: "50",
                max: "12000",
                weekly: "30000",
            },
        ],
    },
    {
        id: 6048,
        paymentType: "CHECKOUTCREDIT",
        name: "Visa/Mastercard",
        description: "Conveniently buy digital currency using your personal VISA or MasterCard.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/checkoutcredit.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: [
            "AED",
            "BRL",
            "CHF",
            "EUR",
            "IDR",
            "INR",
            "KRW",
            "MXN",
            "PHP",
            "QAR",
            "RON",
            "SAR",
            "THB",
            "TWD",
            "VND",
            "ZAR",
        ],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "AED",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AED",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "BRL",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "CHF",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "EUR",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "IDR",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "INR",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "KRW",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "MXN",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "PHP",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "QAR",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "RON",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "SAR",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "THB",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "TWD",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "VND",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "ZAR",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "AED",
                min: "125",
                max: "60000",
                weekly: "130000",
            },
            {
                fiat_code: "BRL",
                min: "200",
                max: "3300",
                weekly: "13000",
            },
            {
                fiat_code: "CHF",
                min: "40",
                max: "15000",
                weekly: "32000",
            },
            {
                fiat_code: "EUR",
                min: "35",
                max: "18000",
                weekly: "75000",
            },
            {
                fiat_code: "IDR",
                min: "550000",
                max: "8250000",
                weekly: "33000000",
            },
            {
                fiat_code: "INR",
                min: "3000",
                max: "50000",
                weekly: "180000",
            },
            {
                fiat_code: "KRW",
                min: "45000",
                max: "18900000",
                weekly: "40500000",
            },
            {
                fiat_code: "MXN",
                min: "650",
                max: "20000",
                weekly: "50000",
            },
            {
                fiat_code: "PHP",
                min: "2000",
                max: "30000",
                weekly: "120000",
            },
            {
                fiat_code: "QAR",
                min: "125",
                max: "59000",
                weekly: "130000",
            },
            {
                fiat_code: "RON",
                min: "35",
                max: "18000",
                weekly: "75000",
            },
            {
                fiat_code: "SAR",
                min: "135",
                max: "61000",
                weekly: "130000",
            },
            {
                fiat_code: "THB",
                min: "1200",
                max: "20000",
                weekly: "80000",
            },
            {
                fiat_code: "TWD",
                min: "1000",
                max: "455750",
                weekly: "1825000",
            },
            {
                fiat_code: "VND",
                min: "850000",
                max: "375000000",
                weekly: "750000000",
            },
            {
                fiat_code: "ZAR",
                min: "600",
                max: "10000",
                weekly: "40000",
            },
        ],
    },
    {
        id: 6053,
        paymentType: "CLEARJUNCTION",
        name: "SEPA",
        description: "Pay for your order directly from your internet banking app, just like paying a bill",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/sepa.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["EUR"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "EUR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "EUR",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "EUR",
                min: "35",
                max: "30000",
                weekly: "70000",
            },
        ],
    },
    {
        id: 6059,
        paymentType: "CLEARJUNCTIONFP",
        name: "Bank Transfer",
        description: "Pay for your order directly from your internet banking app, just like paying a bill",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/faster-payments.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["GBP"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "GBP",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "GBP",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "GBP",
                min: "30",
                max: "30000",
                weekly: "70000",
            },
        ],
    },
    {
        id: 6060,
        paymentType: "CHECKOUTCREDIT",
        name: "Visa/Mastercard",
        description: "Conveniently buy digital currency using your personal VISA or MasterCard.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/checkoutcredit.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["AUD"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "AUD",
                coin_code: "BTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "ETH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "BUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "BNB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "BCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "LINK",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "LTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "XRP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "EOS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "CHZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "BAT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "MANA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "AAVE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "AVAX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "CELO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "COMP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "DOGE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "DOT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "ENJ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "MATIC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "MKR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "ADA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "CUSD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "CVC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "DAI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "ETC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "FIL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "KLAY",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "OMG",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "SNX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "SOL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "SUSHI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "UNI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "WBTC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "XLM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "YFI",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "AXS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "ATOM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "CAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "FLOW",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "FTM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "IMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "GRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "NEAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "ONE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "XTZ",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "APE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "HBAR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "WAXP",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "SOLO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "CRO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "WAVES",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "HNT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "ALGO",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "LRC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "ZKS",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "BOBA",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "EGLD",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "MOB",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "GMX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "XCH",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "XPRT",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "RITE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "PSTAKE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "HEC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "TOR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "KSM",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "MOVR",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "EUROC",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "BRWL",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "SAND",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "TRX",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
            {
                fiat_code: "AUD",
                coin_code: "VERSE",
                fees: [
                    {
                        name: "surcharge",
                        amount: 0.0199,
                        type: "percentage",
                    },
                ],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "AUD",
                min: "50",
                max: "15000",
                weekly: "60000",
            },
        ],
    },
    {
        id: 6063,
        paymentType: "MONOOVAPAYID",
        name: "PayID",
        description: "PayID is a payment method which allows you to make a near‑instant deposit from your Australian bank account to buy digital currency",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/monoovapayid.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["AUD"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "AUD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "AUD",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "AUD",
                min: "50",
                max: "1500",
                weekly: "70000",
            },
        ],
    },
    {
        id: 6077,
        paymentType: "DLOCALZAIO",
        name: "Instant Bank Transfer",
        description: "Instant Bank Transfer via IO",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/dlocalzaio.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["ZAR"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "RUNE",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "ZAR",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "RUNE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "ZAR",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "ZAR",
                min: "600",
                max: "79000",
                weekly: "316000",
            },
        ],
    },
    {
        id: 6081,
        paymentType: "WORLDPAYGOOGLE",
        name: "Google Pay",
        description: "Conveniently buy digital currency using your Google Pay wallet.",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/google-pay.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["USD"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "CELO",
            "COMP",
            "DOGE",
            "DOT",
            "ENJ",
            "MATIC",
            "MKR",
            "ADA",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "KSM",
            "MOVR",
            "EUROC",
            "SAND",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "USD",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "CELO",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "COMP",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "DOGE",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "DOT",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "ENJ",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "MKR",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "ADA",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "USD",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "USD",
                min: "35",
                max: "15000",
                weekly: "60000",
            },
        ],
    },
    {
        id: 6086,
        paymentType: "DLOCALSPEI",
        name: "SPEI",
        description: "Instant Bank Transfer via SE",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/dlocalspei.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["MXN"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "MATIC",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "MXN",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "MXN",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "MXN",
                min: "600",
                max: "90000",
                weekly: "720000",
            },
        ],
    },
    {
        id: 6087,
        paymentType: "DLOCALCOPSE",
        name: "PSE",
        description: "PSE",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/dlocalcopse.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["COP"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "MATIC",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "COP",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "COP",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "COP",
                min: "160000",
                max: "25000000",
                weekly: "200000000",
            },
        ],
    },
    {
        id: 6088,
        paymentType: "DLOCALCLKH",
        name: "Khipu",
        description: "Khipu",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/dlocalclkh.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["CLP"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "MATIC",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "TOR",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "CLP",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "TOR",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "CLP",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "CLP",
                min: "30000",
                max: "6000000",
                weekly: "18000000",
            },
        ],
    },
    {
        id: 6091,
        paymentType: "DLOCALTHQR",
        name: "Wallet Payment",
        description: "Wallet Payment",
        logo_url: "https://bitcoincom.banxa.com/images/payment-providers/dlocalthqr.png",
        status: "ACTIVE",
        supported_agents: null,
        type: "FIAT_TO_CRYPTO",
        supported_fiat: ["THB"],
        supported_coin: [
            "BTC",
            "ETH",
            "USDT",
            "BUSD",
            "BNB",
            "BCH",
            "LINK",
            "LTC",
            "XRP",
            "EOS",
            "USDC",
            "CHZ",
            "BAT",
            "MANA",
            "AAVE",
            "AVAX",
            "MATIC",
            "CUSD",
            "CVC",
            "DAI",
            "ETC",
            "FIL",
            "KLAY",
            "OMG",
            "SNX",
            "SOL",
            "SUSHI",
            "UNI",
            "WBTC",
            "XLM",
            "YFI",
            "AXS",
            "ATOM",
            "CAKE",
            "FLOW",
            "FTM",
            "IMX",
            "GRT",
            "NEAR",
            "ONE",
            "USDP",
            "XTZ",
            "APE",
            "HBAR",
            "WAXP",
            "SOLO",
            "CRO",
            "WAVES",
            "HNT",
            "ALGO",
            "LRC",
            "ZKS",
            "BOBA",
            "EGLD",
            "MOB",
            "GMX",
            "XCH",
            "XPRT",
            "RITE",
            "PSTAKE",
            "HEC",
            "KSM",
            "MOVR",
            "EUROC",
            "BRWL",
            "SAND",
            "TRX",
            "VERSE",
        ],
        transaction_fees: [
            {
                fiat_code: "THB",
                coin_code: "BTC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ETH",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "USDT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BUSD",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BNB",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BCH",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "LINK",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "LTC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "XRP",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "EOS",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "USDC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CHZ",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BAT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MANA",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "AAVE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "AVAX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MATIC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CUSD",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CVC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "DAI",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ETC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "FIL",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "KLAY",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "OMG",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SNX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SOL",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SUSHI",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "UNI",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "WBTC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "XLM",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "YFI",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "AXS",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ATOM",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CAKE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "FLOW",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "FTM",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "IMX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "GRT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "NEAR",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ONE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "USDP",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "XTZ",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "APE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "HBAR",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "WAXP",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SOLO",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "CRO",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "WAVES",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "HNT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ALGO",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "LRC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "ZKS",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BOBA",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "EGLD",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MOB",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "GMX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "XCH",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "XPRT",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "RITE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "PSTAKE",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "HEC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "KSM",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "MOVR",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "EUROC",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "BRWL",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "SAND",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "TRX",
                fees: [],
            },
            {
                fiat_code: "THB",
                coin_code: "VERSE",
                fees: [],
            },
        ],
        transaction_limits: [
            {
                fiat_code: "THB",
                min: "1000",
                max: "20000",
                weekly: "200000",
            },
        ],
    },
];
exports.default = paymentOptions;
//# sourceMappingURL=paymentOptions.js.map